import { lazy } from 'react';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('../../app/page').then((mod) => ({ default: mod.default })));
const DashboardPage = lazy(() => import('../../app/dashboard/page').then((mod) => ({ default: mod.default })));
const PropertiesPage = lazy(() => import('../../app/properties/page').then((mod) => ({ default: mod.default })));
const AgentsPage = lazy(() => import('../../app/agents/page').then((mod) => ({ default: mod.default })));
const AgentProfilePage = lazy(() => import('../../app/agents/[slug]/page').then((mod) => ({ default: mod.default })));
const ClaimAgentPage = lazy(() => import('../../app/agents/claim/page').then((mod) => ({ default: mod.default })));
const CheckPage = lazy(() => import('../../app/check/[query]/page').then((mod) => ({ default: mod.default })));
const ReportPage = lazy(() => import('../../app/r/[reportId]/page').then((mod) => ({ default: mod.default })));
const ClaimPropertyPage = lazy(() => import('../../app/owners/claim/page').then((mod) => ({ default: mod.default })));
const OwnersPage = lazy(() => import('../../app/owners/page').then((mod) => ({ default: mod.default })));
const BetaAccessPage = lazy(() => import('../../app/beta-access/page').then((mod) => ({ default: mod.default })));
const PricingPage = lazy(() => import('../../app/pricing/page').then((mod) => ({ default: mod.default })));
const ContactPage = lazy(() => import('../../app/contact/page').then((mod) => ({ default: mod.default })));
const AboutPage = lazy(() => import('../../app/about/page').then((mod) => ({ default: mod.default })));
const HelpPage = lazy(() => import('../../app/help/page').then((mod) => ({ default: mod.default })));
const IntegrationsPage = lazy(() => import('../../app/integrations/page').then((mod) => ({ default: mod.default })));
const DevelopersPage = lazy(() => import('../../app/developers/page').then((mod) => ({ default: mod.default })));
const ConnectPage = lazy(() => import('../../app/connect/page').then((mod) => ({ default: mod.default })));
const SignInPage = lazy(() => import('../../app/signin/page').then((mod) => ({ default: mod.default })));
const CareersPage = lazy(() => import('../../app/careers/page').then((mod) => ({ default: mod.default })));
const PressPage = lazy(() => import('../../app/press/page').then((mod) => ({ default: mod.default })));
const CookiesPage = lazy(() => import('../../app/cookies/page').then((mod) => ({ default: mod.default })));
const TermsPage = lazy(() => import('../../app/terms/page').then((mod) => ({ default: mod.default })));
const PrivacyPage = lazy(() => import('../../app/privacy/page').then((mod) => ({ default: mod.default })));
const DocsPage = lazy(() => import('../../app/docs/page').then((mod) => ({ default: mod.default })));
const APIPage = lazy(() => import('../pages/APIPage').then((mod) => ({ default: mod.default })));
const NotFoundPage = lazy(() => import('../../app/not-found').then((mod) => ({ default: mod.default })));
const ReportsPage = lazy(() => import('../../app/reports/page').then((mod) => ({ default: mod.default })));
const OwnersDashboardPage = lazy(() => import('../../app/owners/dashboard/page').then((mod) => ({ default: mod.default })));
const AgentsDashboardPage = lazy(() => import('../../app/agents/dashboard/page').then((mod) => ({ default: mod.default })));
const DevelopersDashboardPage = lazy(() => import('../../app/developers/dashboard/page').then((mod) => ({ default: mod.default })));
const CheckoutPage = lazy(() => import('../../app/checkout/page').then((mod) => ({ default: mod.default })));
const AccountPage = lazy(() => import('../../app/account/page').then((mod) => ({ default: mod.default })));

export interface RouteConfig {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  protected?: boolean;
}

export const routes: RouteConfig[] = [
  { path: '/', component: HomePage },
  { path: '/dashboard', component: DashboardPage, protected: true },
  { path: '/reports', component: ReportsPage, protected: true },
  { path: '/properties', component: PropertiesPage },
  { path: '/agents', component: AgentsPage },
  { path: '/agents/:slug', component: AgentProfilePage },
  { path: '/agents/claim', component: ClaimAgentPage },
  { path: '/agents/dashboard', component: AgentsDashboardPage, protected: true },
  { path: '/check/:query', component: CheckPage },
  { path: '/r/:reportId', component: ReportPage },
  { path: '/owners', component: OwnersPage },
  { path: '/owners/claim', component: ClaimPropertyPage },
  { path: '/owners/dashboard', component: OwnersDashboardPage, protected: true },
  { path: '/developers', component: DevelopersPage },
  { path: '/developers/dashboard', component: DevelopersDashboardPage, protected: true },
  { path: '/beta-access', component: BetaAccessPage },
  { path: '/pricing', component: PricingPage },
  { path: '/checkout', component: CheckoutPage, protected: true },
  { path: '/account', component: AccountPage, protected: true },
  { path: '/contact', component: ContactPage },
  { path: '/about', component: AboutPage },
  { path: '/help', component: HelpPage },
  { path: '/integrations', component: IntegrationsPage },
  { path: '/connect', component: ConnectPage },
  { path: '/signin', component: SignInPage },
  { path: '/careers', component: CareersPage },
  { path: '/press', component: PressPage },
  { path: '/cookies', component: CookiesPage },
  { path: '/terms', component: TermsPage },
  { path: '/privacy', component: PrivacyPage },
  { path: '/docs', component: DocsPage },
  { path: '/api', component: APIPage },
  { path: '*', component: NotFoundPage }, // Catch-all for 404
];
